import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';

export function AgeGateModal({ isOpen, onClose }: { isOpen: boolean; onClose: () => void }) {
  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[300] bg-black/90 backdrop-blur-md flex items-center justify-center p-6"
        >
          <div className="max-w-md w-full border border-white/10 bg-[#050505] p-8 text-center rounded-lg relative">
            <h2 className="text-2xl font-serif text-white mb-4"> Altersprüfung</h2>
            <p className="text-neutral-400 mb-8 font-light text-sm">
              Dieser Bereich enthält exklusive Inhalte (18+). Bitte bestätige, dass du volljährig bist.
            </p>
            <div className="flex flex-col gap-4 justify-center relative z-10">
              <button
                onClick={() => {
                  onClose();
                  // Obfuscated link to hide from crawlers
                  const dest = atob("aHR0cHM6Ly93d3cuZmFudnVlLmNvbS9lbWlsaWEuaXZhbm92YV9tb2RlbA==");
                  window.open(dest, '_blank');
                }}
                className="px-6 py-3 bg-white text-black hover:bg-neutral-200 transition-colors uppercase tracking-widest text-xs font-bold md:cursor-none"
              >
                Ich bin 18+ (Eintreten)
              </button>
              <button
                onClick={onClose}
                className="px-6 py-2 border border-transparent text-white/50 hover:text-white transition-colors uppercase tracking-widest text-xs md:cursor-none"
              >
                Abbrechen
              </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export function LightboxModal({ image, onClose }: { image: string | null; onClose: () => void }) {
  return (
    <AnimatePresence>
      {image && (
        <motion.div
          initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
          className="fixed inset-0 z-[200] bg-black/40 backdrop-blur-sm flex items-center justify-center p-4 md:p-10 md:cursor-pointer"
          onClick={onClose}
        >
          <button className="absolute top-6 right-6 text-white/50 hover:text-white"><X size={32} /></button>
          <motion.img
            initial={{ scale: 0.9, y: 20 }} animate={{ scale: 1, y: 0 }}
            src={image}
            className="max-w-full max-h-full object-contain rounded-lg shadow-2xl"
            onContextMenu={(e) => e.preventDefault()}
            draggable={false}
          />
        </motion.div>
      )}
    </AnimatePresence>
  );
}
